import { render } from "./NavigationLinks.vue?vue&type=template&id=88dd6f92&scoped=true"
import script from "./NavigationLinks.vue?vue&type=script&lang=js"
export * from "./NavigationLinks.vue?vue&type=script&lang=js"

import "./NavigationLinks.vue?vue&type=style&index=0&id=88dd6f92&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88dd6f92"]])

export default __exports__